"use client";

import { useEffect, useState } from "react";
import { getModifierShortcutHint } from "@/utils/common/keyboard";

/**
 * Hydration-safe Cmd/Ctrl + `key` label. Returns `undefined` on the server and
 * on the client's first paint so SSR markup matches; after mount resolves to
 * the platform-specific hint (e.g. `⌘J` / `Ctrl+J`).
 */
export function useModifierShortcutHint(key: string): string | undefined {
  const [hint, setHint] = useState<string | undefined>(undefined);

  useEffect(() => {
    setHint(getModifierShortcutHint(key));
  }, [key]);

  return hint;
}

/** The GailGPT dock shortcut label (`⌘G` / `Ctrl+G`). */
export function useAssistantShortcutHint(): string | undefined {
  return useModifierShortcutHint("g");
}
